export default "__VITE_ASSET__43a8d704__"